// tslint:disable: max-line-length triple-equals
import React, { useEffect, useState, useRef } from 'react';
import Avatar from 'lqa-ui/lib/Components/Avatar';
import Icon from 'lqa-ui/lib/Components/Icon';
import './styles.scss';
import { getItem, setItem } from '../../utils/localStorage';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import ControlSelect from 'lqa-ui/lib/Components/ControlSelect';
import ControlTextarea from 'lqa-ui/lib/Components/ControlTextarea';
import {
  deleteActionPlanAttachment,
  getActionPlanById,
  getAssessments,
  getFocusAreaOptions,
  getParentActionPlanInfo,
  updateActionPlanStatus,
  uploadActionPlanAttachment,
} from './apiCaller';
import moment from 'moment';
import { ActionPlanType } from './ActionPlanType';
import { translateActionPlanTypeLabel } from './../../enums/labels/actionPlanTypeLabel';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import DatePicker from 'react-datepicker';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../helpers/showMessage';
import Tags from 'lqa-ui/lib/Components/Tags';
import { uniqBy } from 'lodash';
import { StandardMultiSelect } from '../../components/commons/StandardMultiSelect/StandardMultiSelect';
import { ActionPlanMeasurementType } from './../../enums/ActionPlanMeasurementType';
import { translateActionPlanMeasurementTypeLabel } from './../../enums/labels/actionPlanMeasurementTypeLabel';
import Skeleton from 'react-loading-skeleton';
import { AssessmentType } from '../../enums/AssessmentType';
import { getCustomScores } from '../Dashboard/apiCaller';
import ImageOverlay from 'lqa-ui/lib/Components/ImageOverlay';
import ImageResizeBasic from '../../helpers/ImageResizeBasic';
import {
  getFocusAreaOptionsDefault,
  getSelfAssessmentDetails,
} from './../../requests/actionPlan';
import { isUnauthorized } from '../../utils/common';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import {
  getBrandAndHotelData,
  userHotelDetails,
} from '../../helpers/handleBrandAndHotelData';
import { SwitchHotelModal } from '../../app/common/sharedComponents/SwitchHotelModal';
import { SetDefaultTemplateId } from '../commons/Header/SetDefaultTemplateId';
import { INotificationHotelData } from '../../app/@types/switchHotelModal';
import {
  ContentArea,
  DateAndBackContianer,
  DateInfoContent,
  ActionPlanSeriesBack,
  BorderBox,
  OwnerTable,
  AssessmentTypeTable,
  TextPill,
  CardParentContainer,
  CardParentContent,
  CardInfo,
  TitleMessage,
  TitleInfoContainer,
  AddAttachmentsText,
  LoaderText,
  Table,
  StandardTable,
  NotesContainer,
  NotesTitle,
  RelatedComment,
  MessageDescriptionContainer,
} from './EditActionPlan.styled';
import {
  DeleteIconContainer,
  FileNameContainer,
  GridContent,
  GridItem,
  Thumbnail,
} from '../../components/CreateActionPlan/CreateActionPlan.styled';
import { CloseCircle } from '../../app/common/icons/CloseCircle';
import { HeaderContainer } from '../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { Body4, Body6, Headline6 } from './../../app/common/typography';
import { ActionPlanStatus } from '../../enums/ActionPlanStatus';
import { ActionButton } from './ActionButton';
import { sentryReport } from '../../helpers/sentry';
import {
  getWithoutAssessmentLabel,
  WithoutAssessment,
} from '../../enums/WithoutAssessment';
import { actionPlanAssignedUser } from '../../helpers/actionPlanAssignedUser';
import { FocusAreaSelect } from '../CreateActionPlan/FocusAreaSelect';
import { SearchBoxActionPlanUsers } from '../CreateActionPlan/SearchBoxActionPlanUsers';
import { CustomScoreTypes, ICustomScoreType } from '../../app/@types/customScores';

const EditActionPlan = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const actionPlanDataD = useParams();
  const actionPlanId = actionPlanDataD.id;
  let evnt = actionPlanDataD.evnt;
  const actionPlanSeriesHandler = (data) => {
    if (evnt === 'both' && data.owner.id === userData.user.id) {
      evnt = 'sent';
    }
    navigate(
      `/actionPlansSeries/${evnt}/${selectedAssessment}/${
        data.parentId ? data.parentId : data.id
      }/${data.id}`
    );
  };

  const handleCreateLinkedActionPlan = () => {
    navigate('/createActionPlan', {
      state: { actionPlanData, alreadyAssignedUsers },
    });
  };
  const [actionPlanData, setActionPlanData] = useState<any>(undefined);

  const [assignees, setAssignees] = React.useState<any>(undefined);
  const inputRef = useRef<any>('');
  const [assessmentType, setAssessmentType] = useState('LQA');
  const [assessments, setAssessments] = useState<any>([]);
  const [selectedAssessment, setSelectedAssessment] = useState<any>(undefined);
  const [selectedStandardType, setSelectedStandardType] = useState<CustomScoreTypes>();
  const [customStandardTypes, setCustomStandardTypes] = useState<ICustomScoreType[]>([]);
  const [selectedFocusArea, setSelectedFocusArea] = useState<any>(undefined);
  const [visit, setVisit] = useState<number>();
  const [focusAreaOptions, setFocusAreaOptions] = useState<any>([]);
  const [actionPlanType, setActionPlanType] = useState(undefined);
  const [actionPlanMeasurement, setActionPlanMeasurement] = useState('');
  const [messageTitle, setMessageTitle] = useState<any>(undefined);
  const [messageDescription, setMessageDescription] = useState<any>(undefined);
  const [comments, setComments] = useState<any>(undefined);
  const [selectedTemplateId, setSelectedTemplateId] = useState(undefined);
  const [dueDate, setDueDate] = useState<Date | undefined>(undefined);
  const [attachments, setAttachments] = useState<any>(undefined);
  const [standards, setStandards] = useState<any>([]);
  const [missedStandards, setMissedStandards] = useState<any>([]);
  const [errorState, setErrorState] = useState({
    assignees: false,
    assessmentType: false,
    selectedAssessment: false,
    selectedFocusArea: false,
    actionPlanType: false,
    actionPlanMeasurement: false,
    messageTitle: false,
    dueDate: false,
    missedStandards: false,
    messageDescription: false,
  });
  const [reservationPresent, setReservationPresent] = useState(false);
  const [parentId, setParentId] = useState(null);
  const [parentData, setParentData] = useState<any>(undefined);
  const [attachLoader, setAttachLoader] = useState(false);
  const [isDefault, setIsDefault] = useState(false);
  const [alreadyAssignedUsers, setAlreadyAssignedUsers] = useState<any>([]);
  const [localAttachment, setLocalAttachment] = useState<any>([]);
  const [selfStayStart, setSelfStayStart] = useState<any>(undefined);
  const [searchParams] = useSearchParams();
  const hotelId = searchParams.get('hotelId');
  const { selectedHotel } = userHotelDetails();
  const allHotels = getBrandAndHotelData();
  const hasHotelId: boolean = !!hotelId;
  const [showSwitchHotelModal, setShowSwitchHotelModal] = useState(
    hasHotelId && hotelId != selectedHotel
  );
  const [
    notificationHotelData,
    setNotificationHotelData,
  ] = useState<INotificationHotelData>();
  const type = 'actionPlan';

  async function switchHotelHandler (hotelId) {
    const hotelDetails = allHotels.find(
      (hotel) => parseInt(hotel.id) === parseInt(hotelId)
    );
    const selectedBrand = hotelDetails.brandId;
    setItem('selectedBrand', selectedBrand);
    setItem('selectedClient', hotelDetails.clientId);
    setItem('selectedHotel', hotelDetails.id);
    await SetDefaultTemplateId(hotelDetails.id);
    setShowSwitchHotelModal(false);
  }

  useEffect(() => {
    if (hotelId) {
      const SwitchHotelDetail = allHotels.find(
        (hotel) => parseInt(hotel.id) === parseInt(hotelId)
      );
      const CurrentHotelDetail = allHotels.find(
        (hotel) => parseInt(hotel.id) === parseInt(selectedHotel)
      );
      setNotificationHotelData({
        switchHotel: SwitchHotelDetail.name,
        currentHotel: CurrentHotelDetail.name,
        hotelId,
        type,
      });
    }
  }, []);

  useEffect(() => {
    if (!showSwitchHotelModal) {
      if (actionPlanId) {
        getActionPlanById(actionPlanId)
          .then((response) => {
            setActionPlanData(response);
            setSelectedStandardType(response.standardType);
          })
          .catch((error) => {
            showErrorMessage(
              'Could not Find the Action Plan',
              !isUnauthorized(error)
            );
          });
      }
    }
  }, [showSwitchHotelModal]);

  useEffect(() => {
    if (parentId) {
      getParentActionPlanInfo(parentId)
        .then((response) => {
          setParentData(response);
        })
        .catch((error) => {
          console.error('Could not Find the Action Plan');
        });
    }
  }, [parentId]);
  const userData = getItem('user');
  const isViewer = userData && userData.user && userData.user.isViewer;

  useEffect(() => {
    if (actionPlanData) {
      setAlreadyAssignedUsers([userData.user.id, actionPlanData.owner.id]);
      setSelectedStandardType(actionPlanData.standardType);
      setActionPlanType(actionPlanData.actionPlanType);
      setSelectedAssessment(actionPlanData.assessmentId);
      setActionPlanMeasurement(actionPlanData.measurement);
      setMessageTitle(actionPlanData.messageTitle);
      setComments('');
      setMessageDescription(actionPlanData.messageDescription);
      setSelectedTemplateId(actionPlanData.templateId);
      setDueDate(
        actionPlanData ? new Date(actionPlanData.deadline) : undefined
      );
      setAttachments(actionPlanData.attachments);
      setParentId(actionPlanData.parentId);
      setIsDefault(actionPlanData.isDefault);

      const actionPlanAssignee = actionPlanData && {
        id: actionPlanData.assigned.id,
        userFirstName: actionPlanData.assigned.userFirstName,
        userLastName: actionPlanData.assigned.userLastName,
        text: `${actionPlanData.assigned.userFirstName} ${actionPlanData.assigned.userLastName}`,
      };

      setAssignees([actionPlanAssignee]);
      setMissedStandards(
        uniqBy(
          [
            ...standards,
            ...(opt ? opt.filter((o) => o.selected === true) : []),
          ],
          'standardId'
        ).map((standard) => {
          return {
            standardId: standard.standardId,
            categoryId: standard.categoryId,
            actionPlanId,
          };
        })
      );
    }
  }, [actionPlanData]);
  useEffect(() => {
    setMissedStandards(
      uniqBy(
        [...standards, ...(opt ? opt.filter((o) => o.selected === true) : [])],
        'standardId'
      ).map((standard) => {
        return {
          standardId: standard.standardId,
          categoryId: standard.categoryId,
          actionPlanId,
        };
      })
    );
  }, [focusAreaOptions]);
  useEffect(() => {
    getAssessments()
      .then((response) => {
        if (
          response &&
          response.results.filter((o) => o.assessmentType === 'reservation')
            .length > 0
        ) {
          setReservationPresent(true);
        }
        if (selectedAssessment) {
          getSelfAssessmentDetails(selectedAssessment).then((res) => {
            if (res) {
              if (res.assessmentType == 'self') {
                setSelfStayStart(res.stayStart);
              }
              setAssessmentType(res.assessmentType);
            }
          });
        }
        setAssessments(response);
        if (selectedAssessment) {
          const d = response.results.find(
            (res) => res.id === selectedAssessment
          );
          if (d) {
            setSelectedAssessment(d.id);
            setSelectedTemplateId(d.templateId);
            setAssessmentType(d.assessmentType);
          }
        }
      })
      .catch((err) => {
        showErrorMessage(
          'Could not find the Assessment Data',
          !isUnauthorized(err)
        );
      });
    if (selectedHotel) {
      getCustomScores(selectedHotel)
        .then((response) => {
          setCustomStandardTypes(response);
        })
        .catch((err) => {
          showErrorMessage(
            'Could not find Custom Standard Types',
            !isUnauthorized(err)
          );
        });
    }
  }, [selectedAssessment]);

  useEffect(() => {
    setFocusAreaOptions([]);
    if (actionPlanData && selectedAssessment && !isDefault) {
      getFocusAreaOptions(
        selectedAssessment,
        selectedStandardType,
        selectedTemplateId,
        actionPlanId ? parseInt(actionPlanId) : undefined
      )
        .then((response) => {
          setFocusAreaOptions(response);
          setSelectedFocusArea(actionPlanData.focusAreaCategoryId);
          setVisit(actionPlanData.visit);
        })
        .catch((error) => {
          showErrorMessage('Unable to set focus area', !isUnauthorized(error));
        });
    } else if (actionPlanData && isDefault) {
      getFocusAreaOptionsDefault(
        actionPlanId ? parseInt(actionPlanId) : undefined
      )
        .then((res) => {
          setFocusAreaOptions({ categories: res });
          setSelectedFocusArea(actionPlanData.focusAreaCategoryId);
          setVisit(actionPlanData.visit);
        })
        .catch((err) => {
          showErrorMessage(
            'Could not load Focus Area Options',
            !isUnauthorized(err)
          );
        });
    }
  }, [actionPlanData, selectedAssessment, selectedStandardType]);

  const handleImageUpload = (
    localAttachment,
    isAnyFailedFileUploadEntries,
    isSubmit
  ) => {
    if (!localAttachment || !localAttachment.length) {
      setItem('isFormData', false);
      showSuccessMessage(`${isSubmit ? 'Submitted' : 'Saved'} Successfully`);
      navigate('/myactions');
    } else {
      for (const [index, file] of localAttachment.entries()) {
        const formData = new FormData();
        formData.append('file', file);
        uploadFileToActionPlan(file, false)
          .then((response) => {
            if (response) {
              if (index == localAttachment.length - 1) {
                setItem('isFormData', false);
                showSuccessMessage('Submitted Successfully');
                navigate('/myactions');
              }
            }
          })
          .catch((error) => {
            isAnyFailedFileUploadEntries = true;
            showErrorMessage('Unable to Save Attachment');
          });
      }
    }
  };

  const updateActionStatus = (action) => {
    if (comments.length <= 0) {
      showErrorMessage('Please fill some comments');
      return;
    }

    const payLoad = {
      id: actionPlanData.id,
      action,
      assigneeComments: `${actionPlanData.assigneeComments || ''}
    ${
      comments.length > 1
        ? userData.user.userFirstName +
          ' ' +
          userData.user.userLastName +
          '##' +
          moment().format('l') +
          ' at ' +
          moment().format('LT') +
          '$$ ' +
          comments +
          '^^'
        : ''
    }`,
    };
    if (actionPlanData.id) {
      updateActionPlanStatus(actionPlanData.id, payLoad)
        .then((response) => {
          const isAnyFailedFileUploadEntries = false;
          if (response) {
            handleImageUpload(
              localAttachment,
              isAnyFailedFileUploadEntries,
              false
            );
          }
        })
        .catch((error) => {
          sentryReport(error.response.data, error.message, error.code, {
            alertMessage: t(
              'COMMON.ALERT_MESSAGES.UNABLE_TO_UPDATE_ACTION_PLAN'
            ),
            method: 'updateActionStatus',
            payload: payLoad,
          });
          showErrorMessage(
            t('COMMON.ALERT_MESSAGES.UNABLE_TO_UPDATE_ACTION_PLAN')
          );
        });
    }
  };

  const getImages = (a) => {
    return [{ source: a.url, notes: a.name || a.notes }];
  };

  const formChangeHandler = () => {
    setItem('isFormData', true);
  };

  const uploadFileToActionPlan = async (file, showMessage = true) => {
    if (!file || file.size > 500000000) {
      showErrorMessage(' Invalid file.Please check file size or file type.');
      return;
    }
    setAttachLoader(true);
    const formData = new FormData();
    formData.append('file', file);
    const att = [...attachments];
    const response = await uploadActionPlanAttachment(
      actionPlanData.id,
      formData
    );
    if (response) {
      att.push({
        name: file.name,
        id: response,
        url: URL.createObjectURL(file),
        type: file.type,
      });
      setAttachments(att);
      setAttachLoader(false);
      if (showMessage) {
        showSuccessMessage('File Uploaded Successfully.');
      }
    } else {
      setAttachLoader(false);
      showErrorMessage(' Invalid file.Please check file size or file type.');
    }
    return response;
  };
  const handleDeleteAttachment = (fileId, fileName) => {
    if (!fileId) {
      return;
    }
    deleteActionPlanAttachment(actionPlanData.id, fileId, fileName)
      .then((resp) => {
        const remainingAttach = attachments.filter(
          (o) => parseInt(o.id) !== parseInt(fileId)
        );
        setAttachments(remainingAttach);
        showSuccessMessage('Attachment removed successfully.');
      })
      .catch((e) => {
        showErrorMessage('You are not authorized to delete this attachment.');
      });
  };

  const category =
    focusAreaOptions &&
    focusAreaOptions.categories &&
    focusAreaOptions.categories.find(
      (focusArea) =>
        focusArea.categoryId.toString() == selectedFocusArea &&
        focusArea.visit === visit
    );
  let opt = category ? category.missedStandards : undefined;
  const AttachmentContainer = (file, isLocalAttachment) => {
    return (
      <>
        <GridItem key={file.name}>
          <Thumbnail
            src={isLocalAttachment ? URL.createObjectURL(file) : file.url}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = '/assets/img/file.png';
            }}
          />

          <DeleteIconContainer
            onClick={() => {
              if (
                actionPlanData.status !== ActionPlanStatus.complete &&
                !(
                  actionPlanAssignedUser(actionPlanData).id ==
                    parseInt(userData.user.id) &&
                  actionPlanData.status === ActionPlanStatus.awaitingApproval
                ) &&
                !isLocalAttachment
              ) {
                handleDeleteAttachment(file.id, file.name);
              }

              if (isLocalAttachment) {
                setLocalAttachment(
                  localAttachment.filter(
                    (localFile) => localFile.name !== file.name
                  )
                );
              }
            }}
          >
            <CloseCircle />
          </DeleteIconContainer>

          <FileNameContainer>{file.name}</FileNameContainer>
        </GridItem>
      </>
    );
  };

  const actionPlanStatusColors = {
    [ActionPlanStatus.awaitingApproval]: '#f2cb15',
    [ActionPlanStatus.open]: '#8ca7c4',
    [ActionPlanStatus.rejected]: '#cc3044',
    [ActionPlanStatus.complete]: '#219917',
  };

  return (
    <>
      {actionPlanDataD.root === 'from-series' ? (
        <HeaderContainer>
          <AppHeader title={t('COMMON.ACTION_PLAN.SERIES_TITLE')} />
        </HeaderContainer>
      ) : (
        <HeaderContainer>
          <AppHeader title={t('COMMON.MY_ACTIONS.ACTIONS.ACTION_PLAN')} />
        </HeaderContainer>
      )}
      {!actionPlanData ||
      !assignees ||
      !selectedStandardType ||
      !dueDate ||
      !attachments ||
      assessments.length <= 0 ? (
        <ContentArea>
          <div className="m-10 mt-20">
            <div className="box-shadow d-block mb-10">
              <Skeleton
                containerClassName="flex-1"
                height={100}
                borderRadius={5}
              />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div>
              <Skeleton width={80} height={30} borderRadius={5} />
              <Skeleton width={350} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <div className="row-separater-skeleton mb-10">
              <Skeleton width={150} height={50} borderRadius={5} />
              <Skeleton width={180} height={50} borderRadius={5} />
            </div>
            <Skeleton
              containerClassName="flex-1"
              height={50}
              borderRadius={5}
            />
          </div>
        </ContentArea>
      ) : (
        <ContentArea>
          {(parentData || actionPlanData.hasChild) && (
            <DateAndBackContianer>
              {actionPlanDataD.root === 'from-series' && !parentData ? (
                <DateInfoContent>
                  <Headline6 color="redCrayola">DUE: </Headline6>
                  <Body6
                    color={
                      moment(dueDate) < moment() ? 'redCrayola' : 'oxfordBlue'
                    }
                  >
                    {moment(dueDate).format('DD MMM YY')}
                  </Body6>
                </DateInfoContent>
              ) : (
                <div />
              )}
              <div>
                <ActionPlanSeriesBack
                  color="azure"
                  onClick={() => actionPlanSeriesHandler(actionPlanData)}
                >
                  Action Plan Series
                </ActionPlanSeriesBack>
              </div>
            </DateAndBackContianer>
          )}
          {actionPlanDataD.root === 'from-series' && parentData && (
            <CardParentContainer>
              <CardParentContent>
                <CardInfo>
                  <Avatar
                    name={`${parentData.owner.userFirstName
                      .split(' ')
                      .join('')} ${parentData.owner.userLastName
                      .split(' ')
                      .join('')}`}
                    size={65}
                    style={{ background: '#4fada6' }}
                  />
                  <TitleInfoContainer>
                    <Body6 color="eerieBlack">{`${
                      parentData.owner.userLastName.charAt(0).toUpperCase() +
                      parentData.owner.userLastName.slice(1)
                    }, ${
                      parentData.owner.userFirstName.charAt(0).toUpperCase() +
                      parentData.owner.userFirstName.slice(1)
                    }`}</Body6>
                    <Body6 color="battleShipGray">
                      Recieved:{' '}
                      {moment(parentData.insertDate).format('DD MMMM YYYY')}
                    </Body6>
                    <TitleMessage>
                      <Headline6 color="battleShipGray">
                        Message Title:{' '}
                      </Headline6>
                      <Body6 color="battleShipGray">
                        {parentData.messageTitle}
                      </Body6>
                    </TitleMessage>
                  </TitleInfoContainer>
                </CardInfo>
                <Icon kind="attach-link" height={12} width={12} />
              </CardParentContent>
              <hr />
              <DateInfoContent>
                <Body6 color="redCrayola">Due Date: </Body6>
                <Body6
                  color={
                    moment(parentData.deadline) < moment()
                      ? 'redCrayola'
                      : 'battleShipGray'
                  }
                >
                  {moment(parentData.deadline).format('DD MMMM YYYY')}
                </Body6>
              </DateInfoContent>
            </CardParentContainer>
          )}
          <>
            <div>
              <BorderBox>
                <OwnerTable className="addActionPlanForm ">
                  <tr>
                    <td>
                      <Body6 color="eerieBlack">Owner</Body6>
                    </td>
                    <td>{`${
                      actionPlanData.owner.userLastName
                        .charAt(0)
                        .toUpperCase() +
                      actionPlanData.owner.userLastName.slice(1)
                    }, ${
                      actionPlanData.owner.userFirstName
                        .charAt(0)
                        .toUpperCase() +
                      actionPlanData.owner.userFirstName.slice(1)
                    }`}</td>
                  </tr>
                  <tr>
                    <td>
                      <Body6 color="eerieBlack">Assigned To</Body6>
                    </td>
                    <td>
                      <SearchBoxActionPlanUsers
                        initialState={assignees}
                        disabled={true}
                      />
                    </td>
                  </tr>
                </OwnerTable>
              </BorderBox>
              <AssessmentTypeTable className="addActionPlanForm">
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Assessment Type:</Body6>
                  </td>
                  <td>
                    <ControlSelect
                      className={`${
                        errorState.assessmentType ? 'red-border' : ''
                      }`}
                      layout="pillbutton"
                      value={assessmentType}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        setAssessmentType(selectedValue);
                        setSelectedAssessment(undefined);
                        setSelectedFocusArea(undefined);
                        setSelectedTemplateId(undefined);
                        formChangeHandler();
                      }}
                      disabled={true}
                    >
                      <option key={1} value={'LQA'}>
                        {'LQA'}
                      </option>
                      {reservationPresent && (
                        <option key={1} value={'reservation'}>
                          {AssessmentType.reservation}
                        </option>
                      )}
                      {selfStayStart && (
                        <option key={2} value={'self'}>
                          {AssessmentType.self}
                        </option>
                      )}
                    </ControlSelect>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Status</Body6>
                  </td>
                  <td>
                    <TextPill
                      color={actionPlanStatusColors[actionPlanData.status]}
                    >
                      {actionPlanData.status}
                    </TextPill>
                  </td>
                </tr>

                <tr>
                  <td>
                    <Body6 color="eerieBlack">Attachments:</Body6>
                  </td>
                  <td>
                    {(actionPlanData.status !== ActionPlanStatus.complete &&
                      !(
                        actionPlanAssignedUser(actionPlanData).id ==
                          parseInt(userData.user.id) &&
                        actionPlanData.status ===
                          ActionPlanStatus.awaitingApproval
                      )) ||
                    (actionPlanData.owner.id === userData.user.id &&
                      actionPlanData.status ===
                        ActionPlanStatus.awaitingApproval) ? (
                      <ImageResizeBasic
                        onImageCompletion={(file) => {
                          setLocalAttachment((prevState) => [
                            ...prevState,
                            file,
                          ]);
                        }}
                        uploadImageComponent={
                          <AddAttachmentsText>
                            Add Attachments
                          </AddAttachmentsText>
                        }
                      />
                    ) : (
                      <AddAttachmentsText>Add Attachments</AddAttachmentsText>
                    )}

                    <input
                      ref={inputRef}
                      type="file"
                      multiple={true}
                      accept="application/pdf,text/*,image/*,.xls,.xlsx,.doc,.docx,video/mp4,video/x-m4v,video/*,audio/*,
                              audio/mp3, audio/wav, audio/ogg, audio/m4a, audio/flac, audio/aac"
                      className="d-none"
                      onChange={(e) => {
                        if (
                          e &&
                          e.target &&
                          e.target.files &&
                          e.target.files[0] &&
                          userData.user.id ==
                            actionPlanAssignedUser(actionPlanData).id
                        ) {
                          const file = e.target.files[0];
                          setAttachments((prevState) => [...prevState, file]);
                        } else if (
                          e &&
                          e.target &&
                          e.target.files &&
                          e.target.files[0]
                        ) {
                          uploadFileToActionPlan(e.target.files[0]);
                        }
                        inputRef.current.value = null;
                      }}
                    />
                  </td>
                </tr>
                {attachLoader ? (
                  <>
                    <LoadingContent layout="flex" />
                    <LoaderText>Please wait</LoaderText>
                  </>
                ) : (
                  <></>
                )}
                {attachments.length >= 0 && (
                  <tr>
                    <td colSpan={2}>
                      <GridContent>
                        {attachments &&
                          attachments.length > 0 &&
                          attachments.map((file, index) => (
                            <ImageOverlay
                              key={index}
                              images={getImages(file)}
                              target={
                                <span key={file + 'attachments'}>
                                  {AttachmentContainer(file, false)}
                                </span>
                              }
                            />
                          ))}
                        {localAttachment &&
                          localAttachment.length > 0 &&
                          localAttachment.map((file, index) => (
                            <ImageOverlay
                              key={index}
                              images={getImages(file)}
                              target={
                                <span key={index + 'attachments'}>
                                  {AttachmentContainer(file, true)}
                                </span>
                              }
                            />
                          ))}
                      </GridContent>
                    </td>
                  </tr>
                )}
              </AssessmentTypeTable>
              <Table className="addActionPlanForm">
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Assessment:</Body6>
                  </td>
                  <td>
                    <ControlSelect
                      disabled={true}
                      value={
                        selectedAssessment && !isDefault
                          ? selectedAssessment.toString()
                          : WithoutAssessment.NoAssessmentAdded
                      }
                      onChange={(e) => {
                        const assessmentId = e.target.value || '';
                        const templateId =
                          e.target.value && assessments
                            ? assessments.results.find(
                                (o) => o.id === parseInt(assessmentId)
                              )!.template.id
                            : '';
                        setSelectedAssessment(assessmentId);
                        setSelectedTemplateId(templateId);
                        setSelectedFocusArea(undefined);
                        formChangeHandler();
                      }}
                    >
                      <option value={WithoutAssessment.NoAssessmentAdded}>
                        {getWithoutAssessmentLabel(
                          WithoutAssessment.NoAssessmentAdded
                        )}
                      </option>
                      {selfStayStart && (
                        <option
                          key={selectedAssessment}
                          value={selectedAssessment.toString()}
                        >
                          {moment(selfStayStart.toString()).format('Do MMM YY')}
                        </option>
                      )}
                      {!selfStayStart &&
                        assessments &&
                        assessments.results &&
                        assessments.results
                          .filter((o) => o.assessmentType === assessmentType)
                          .map((assessment) => (
                            // tslint:disable-next-line:jsx-key
                            <option value={assessment.id.toString()}>
                              {moment(assessment.stayStart).format('Do MMM YY')}
                            </option>
                          ))}
                    </ControlSelect>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Standard:</Body6>
                  </td>
                  <td>
                    <ControlSelect
                      disabled={true}
                      value={selectedStandardType || 'LQA'}
                      onChange={(e) => {
                        formChangeHandler();
                        setSelectedStandardType(e.target.value);
                      }}
                    >
                      {customStandardTypes && customStandardTypes.map((customStandardType, index) => (
                        <option
                          key={index}
                          value={customStandardType.customScoreType}
                        >
                          {customStandardType.customScoreName}
                        </option>
                      ))}
                    </ControlSelect>
                  </td>
                </tr>
              </Table>
              <Table className="addActionPlanForm">
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Focus Area:</Body6>
                  </td>
                  <td>
                    <FocusAreaSelect
                      focusAreaOptions={focusAreaOptions}
                      selectedFocusArea={selectedFocusArea}
                      visit={visit}
                      focusAreaCallback={() => {}}
                      isDisabled={true}
                    />
                  </td>
                </tr>
              </Table>
              <table className="addActionPlanForm">
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Standard:</Body6>
                  </td>
                </tr>
              </table>
              <StandardTable className="addActionPlanForm">
                <tr>
                  <td colSpan={2}>
                    <StandardMultiSelect
                      className={`standard-multi-select ${
                        errorState.missedStandards ? 'red-border' : ''
                      }`}
                      options={uniqBy(opt, 'standardId')}
                      selected={uniqBy(
                        [
                          ...standards,
                          ...(opt
                            ? opt.filter((o) => o.selected === true)
                            : []),
                        ],
                        'standardId'
                      )}
                      missedStandards={
                        opt ? opt.filter((o) => o.selected === true) : []
                      }
                      onChange={(stds) => {
                        formChangeHandler();
                        setStandards(stds);
                        setMissedStandards(
                          stds.map((standard) => {
                            opt = opt.map((o) => {
                              if (o.standardId !== standard.standardId) {
                                o.selected = false;
                              }
                              return o;
                            });

                            return {
                              standardId: standard.standardId,
                              categoryId: standard.categoryId,
                              actionPlanId,
                            };
                          })
                        );
                      }}
                      placeholder={'Start typing to select…'}
                      disabled={true}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} className="standard-tag">
                    <Tags
                      data={uniqBy(
                        [
                          ...standards,
                          ...(opt
                            ? opt.filter((o) => o.selected === true)
                            : []),
                        ],
                        'standardId'
                      )}
                      onRemove={(tag) => {
                        if (
                          actionPlanData.status == ActionPlanStatus.open &&
                          actionPlanData.owner.id == userData.user.id
                        ) {
                          setStandards(
                            uniqBy(
                              [
                                ...standards,
                                ...(opt
                                  ? opt.filter((o) => o.selected === true)
                                  : []),
                              ],
                              'standardId'
                            ).filter(
                              (existing) =>
                                existing.standardId !== tag.standardId
                            )
                          );
                          setMissedStandards(
                            uniqBy(
                              [
                                ...standards,
                                ...(opt
                                  ? opt.filter((o) => o.selected === true)
                                  : []),
                              ],
                              'standardId'
                            )
                              .filter(
                                (existing) =>
                                  existing.standardId !== tag.standardId
                              )
                              .map((standard) => {
                                opt = opt.map((o) => {
                                  if (o.standardId !== standard.standardId) {
                                    o.selected = false;
                                  }
                                  return o;
                                });

                                return {
                                  standardId: standard.standardId,
                                  categoryId: standard.categoryId,
                                  actionPlanId,
                                };
                              })
                          );
                        }
                      }}
                    />
                  </td>
                </tr>
              </StandardTable>
              <Table className="addActionPlanForm">
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Action:</Body6>
                  </td>
                  <td>
                    <ControlSelect
                      className={` ${errorState.actionPlanType ? 'red' : ''}`}
                      disabled={true}
                      value={actionPlanType || ''}
                      onChange={(e) => {
                        formChangeHandler();
                        setActionPlanType(e.target.value);
                      }}
                    >
                      <option value="" />
                      {Object.keys(ActionPlanType).map((value, index) => (
                        <option key={index} value={value}>
                          {translateActionPlanTypeLabel(
                            value as ActionPlanType
                          )}
                        </option>
                      ))}
                    </ControlSelect>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Measurement:</Body6>
                  </td>
                  <td>
                    <ControlSelect
                      disabled={true}
                      className={` ${errorState.actionPlanMeasurement ? 'red' : ''}`}
                      value={actionPlanMeasurement || ''}
                      onChange={(e) => {
                        formChangeHandler();
                        setActionPlanMeasurement(e.target.value);
                      }}
                    >
                      <option value="" />
                      {Object.keys(ActionPlanMeasurementType).map(
                        (value, index) => (
                          <option key={index} value={value}>
                            {translateActionPlanMeasurementTypeLabel(
                              value as ActionPlanMeasurementType
                            )}
                          </option>
                        )
                      )}
                    </ControlSelect>
                  </td>
                </tr>
              </Table>
              <Table className="addActionPlanForm">
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Due Date:</Body6>
                  </td>
                  <td>
                    <DatePicker
                      className={`date-picker ${
                        errorState.dueDate ? 'red-border' : ''
                      } `}
                      disabled={true}
                      dateFormat="dd-MM-yyyy"
                      showIcon={true}
                      selected={dueDate}
                      onChange={(selectedDate) => {
                        formChangeHandler();
                        if (selectedDate) {
                          setDueDate(selectedDate);
                        }
                      }}
                    />
                  </td>
                </tr>
              </Table>
              <Table className="addActionPlanForm">
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Message Title</Body6>
                  </td>
                  <td>
                    <ControlInput
                      className={` ${
                        errorState.messageTitle ? 'red-border' : ''
                      }`}
                      disabled={true}
                      value={messageTitle || ''}
                      onChange={(e) => {
                        setMessageTitle(e.target.value);
                        formChangeHandler();
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Body6 color="eerieBlack">Message Description</Body6>
                  </td>
                  <td />
                </tr>
                <tr>
                  <td colSpan={2}>
                    <MessageDescriptionContainer
                      error={errorState.messageDescription}
                    >
                      {messageDescription || ''}
                    </MessageDescriptionContainer>
                  </td>
                </tr>
              </Table>
              <Table className="addActionPlanForm">
                {actionPlanData.assigneeComments &&
                  actionPlanData.assigneeComments.split('^^').map((o, i) => {
                    const [nameTime, relatedComment] = o.split('$$');
                    const [name, time] = nameTime.split('##');
                    return actionPlanData.assigneeComments.split('^^').length -
                      1 >
                      i ? (
                      <tr>
                        <td>
                          <NotesContainer>
                            <NotesTitle>
                              <Body4 color="battleShipGray">
                                Notes from{' '}
                                {name.includes(userData.user.userFirstName) &&
                                name.includes(userData.user.userLastName)
                                  ? 'Me'
                                  : name}
                              </Body4>
                              <Body4 color="battleShipGray">{time}</Body4>
                            </NotesTitle>
                            <RelatedComment>{relatedComment}</RelatedComment>
                          </NotesContainer>
                        </td>
                      </tr>
                    ) : (
                      <></>
                    );
                  })}
                <tr>
                  <td>
                    <ControlTextarea
                      minRows={1}
                      disabled={
                        actionPlanData.status === ActionPlanStatus.complete
                      }
                      value={comments}
                      onChange={(e) => {
                        setComments(e.target.value);
                        formChangeHandler();
                      }}
                      placeholder="Add Comments"
                    />
                  </td>
                </tr>
              </Table>
            </div>
            <ActionButton
              actionPlanData={actionPlanData}
              updateActionStatus={updateActionStatus}
              event={actionPlanDataD.evnt}
              root={actionPlanDataD.root}
              parentId={actionPlanData.parentId}
              isViewer={isViewer}
              handleCreateLinkedActionPlan={handleCreateLinkedActionPlan}
            />
          </>
        </ContentArea>
      )}
      {showSwitchHotelModal && notificationHotelData && (
        <SwitchHotelModal
          showSwitchHotelModal={showSwitchHotelModal}
          handleModalClose={() => setShowSwitchHotelModal(false)}
          switchHotelHandler={switchHotelHandler}
          notificationHotelData={notificationHotelData}
        />
      )}
    </>
  );
};

export default EditActionPlan;
